import React, { Component } from 'react';
import { css } from '@emotion/core';
import './TopHeaderSecondary.scss';

import DeliveryInfo from './DeliveryInfo';
import SocialMedia from './SocialMedia';
import AssistanceInfo from './AssistanceInfo';
import { connect } from 'react-redux';

class TopHeaderSecondary extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      isMobile,
      isCheckout,
      phone,
      phone2,
      primaryColor,
      datiFarmacia,
      shippingDescription,
      freeShippingThreshold,
      topHeaderSecondaryVersion,
    } = this.props;

    const topHeaderSecondaryStyle = css`
      & .container.container-header-secondary {
        .left-top-header-secondary {
          .delivery-info-container .delivery-info > svg > path {
            fill: ${primaryColor};
          }
        }
        .right-top-header-secondary {
          .assistance a {
            color: ${primaryColor} !important;
            text-decoration: none;
          }
        }
      }
      .container-header-secondary.version-2 {
        max-width: 94%;
        container-header-secondary {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .container-header-secondary.version-3 {
        max-width: 94%;
        container-header-secondary {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    `;

    if (isMobile) {
      return null;
    }

    return (
      <div
        className="top-header-secondary desktop"
        style={{
          height: topHeaderSecondaryVersion === 2 ? '34px' : '37px',
        }}
      >
        <div
          className={`desktop-version version-${topHeaderSecondaryVersion}`}
          css={topHeaderSecondaryStyle}
        >
          {!isCheckout && (
            <div className="container container-header-secondary">
              <div className="left-top-header-secondary">
                <DeliveryInfo
                  shippingDescription={shippingDescription}
                  freeShippingThreshold={freeShippingThreshold}
                  topHeaderSecondaryVersion={topHeaderSecondaryVersion}
                  primaryColor={primaryColor}
                />
              </div>

              <div className="right-top-header-secondary">
                {topHeaderSecondaryVersion === 2 && (
                  <SocialMedia
                    datiFarmacia={datiFarmacia}
                    topHeaderSecondaryVersion={topHeaderSecondaryVersion}
                  />
                )}
                <AssistanceInfo
                  phone={phone}
                  phone2={phone2}
                  primaryColor={primaryColor}
                />
              </div>
            </div>
          )}
        </div>

        <div className="mobile-version"></div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
  };
}

export default connect(mapStateToProps)(TopHeaderSecondary);
